/**
 * 2007-2017 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2017 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from "jquery";
import prestashop from "prestashop";
import ProductGallery from "./ProductGallery";
$(() => {
  createProductSpin();
  prestashop.on("clickQuickView", function(elm) {
    let data = {
      action: "quickview",
      id_product: elm.dataset.idProduct,
      id_product_attribute: elm.dataset.idProductAttribute
    };
    $.post(prestashop.urls.pages.product, data, null, "json").then(function(resp) {
      $("body").append(resp.quickview_html);
      let productModal = $(`#quickview-modal-${resp.product.id}-${resp.product.id_product_attribute}`);
      productModal.modal("show");
      productModal.on("hidden.bs.modal", function() {
        productModal.remove();
      });
      productModal.on("shown.bs.modal", function() {
        productConfig();
        createProductSpin();
      });
    }).fail((resp) => {
      prestashop.emit("handleError", {eventType: "clickQuickView", resp});
    });
  });
  var productConfig = () => {
    let gallery = new ProductGallery();
    gallery.init();
  };
  prestashop.on("updatedProductList", (event) => {
    createProductSpin();
    initNiceSelect();
  });
  prestashop.on("updatedProduct", () => {
    setTimeout(() => {
      createProductSpin();
    }, 1);
  });
});
function createProductSpin() {
  const $spin = $(".js-product-spin").not("[data-spin-added]");
  $spin.each((i, el) => {
    const $el = $(el);
    $el.TouchSpin({
      buttondown_class: "btn js-touchspin",
      buttonup_class: "btn js-touchspin",
      min: parseInt($el.attr("min"), 10),
      max: 1e6
    }).data("spin-added");
  });
}
function initNiceSelect() {
  $("select:not(.niceselect-ignore)").niceSelect();
}
